export const CENSUS_MANAGEMENT_PATH = '/v2-census-management'
export const CENSUS_REVIEW_PATH = '/census-review'
export const CENSUS_MANAGEMENT_V1 = '/census-management'
// used in paginated requests
export const DEFAULT_ROWS_PAGINATION_LIMIT = 100
export const DEFAULT_FILES_PAGINATION_LIMIT = 10

export const DEFAULT_PAGINATION_PAGE_SIZES = [10, 20, 50, 100]
// Default to the largest option so records tables load 100 rows per page,
// matching Census Review and letting reviewers Ctrl+F across all rendered rows.
export const DEFAULT_PAGINATION_PAGE_SIZE = 100
